"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useProductListingPagination = void 0;
var _react = require("react");
var _contexts = require("../../../contexts");
var _constants = require("../constants");
const useProductListingPagination = ()=>{
    const { content, isPLP, loadMoreItems } = (0, _contexts.useBannerProductListingContext)();
    const numberOfLoadedProducts = (0, _react.useMemo)(()=>{
        var _content_rows;
        var _content_rows_reduce;
        return (_content_rows_reduce = content === null || content === void 0 ? void 0 : (_content_rows = content.rows) === null || _content_rows === void 0 ? void 0 : _content_rows.reduce((acc, item)=>acc + item.content.filter((contentItem)=>(contentItem === null || contentItem === void 0 ? void 0 : contentItem.__typename) === 'Product').length, 0)) !== null && _content_rows_reduce !== void 0 ? _content_rows_reduce : 0;
    }, [
        content === null || content === void 0 ? void 0 : content.rows
    ]);
    const initialNumberOfLoadedBanners = (0, _react.useMemo)(()=>{
        var _content_rows;
        var _content_rows_reduce;
        return (_content_rows_reduce = content === null || content === void 0 ? void 0 : (_content_rows = content.rows) === null || _content_rows === void 0 ? void 0 : _content_rows.reduce((acc, item)=>acc + item.content.filter((contentItem)=>(contentItem === null || contentItem === void 0 ? void 0 : contentItem.__typename) === 'EditorialPlpPromoBanner').length, 0)) !== null && _content_rows_reduce !== void 0 ? _content_rows_reduce : 0;
    }, // eslint-disable-next-line react-compiler/react-compiler -- intended eslint ignore
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we don't need to recalculate this value
    []);
    var _content_totalProductsCount;
    const totalProductsCount = (_content_totalProductsCount = content === null || content === void 0 ? void 0 : content.totalProductsCount) !== null && _content_totalProductsCount !== void 0 ? _content_totalProductsCount : 0;
    var _content_totalBannersCount;
    const totalBannersCount = (_content_totalBannersCount = content === null || content === void 0 ? void 0 : content.totalBannersCount) !== null && _content_totalBannersCount !== void 0 ? _content_totalBannersCount : 0;
    const shouldRenderPagination = (0, _react.useMemo)(()=>!(totalProductsCount + totalBannersCount < _constants.PAGINATION_LIMIT_ITEMS && initialNumberOfLoadedBanners === totalBannersCount), [
        totalProductsCount,
        totalBannersCount,
        initialNumberOfLoadedBanners
    ]);
    const shouldRenderItemCount = (0, _react.useMemo)(()=>!(totalProductsCount === 0 && isPLP), [
        totalProductsCount,
        isPLP
    ]);
    return {
        loadMoreItems,
        shouldRenderPagination,
        shouldRenderItemCount,
        numberOfLoadedProducts,
        totalProductsCount
    };
};
exports.useProductListingPagination = useProductListingPagination;
